// extracted by mini-css-extract-plugin
export var animationContainer = "_c8-0";
export var asteriskIcon = "_c8-8";
export var conversationLeftSection = "_c8-4";
export var conversationListItem = "_c8-3";
export var conversationMiddleSection = "_c8-5";
export var conversationRightSection = "_c8-6";
export var detailsContent = "_c8-1";
export var listContainer = "_c8-7";
export var modalContent = "_c8-2";